/*
 * -----------------------------------------------------------------------
 *  <copyright file="reset-password-modal.tsx" company="Triumph Research Intelligence">
 *      Copyright (C) 2019 by Triumph Research Intelligence. All rights reserved.
 *  </copyright>
 * -----------------------------------------------------------------------
 */

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';

import { useTranslation, useBoolean } from '../../../../hooks';
import Settings from '../../../../settings/settings';
import Button from '../../core/buttons/button';
import { CustomDialog, DialogContent, DialogTitle, DialogActions } from '../../core/dialog';

import './styles.scss';

const ResetPasswordModal = ({
    onClose,
    open,
    email,
    orgCode,
}: {
    onClose: Function;
    open: boolean;
    email: string;
    orgCode: string;
}) => {
    const { t } = useTranslation();

    const saving = useBoolean(false);

    const resetPassword = () => {
        saving.setTrue();
        fetch(`${Settings.api.url()}/api/forgotpassword`, {
            method: 'POST',
            body: JSON.stringify({ Email: email, OrganisationCode: orgCode }),
            headers: {
                'Content-Type': 'application/json',
            },
        })
            .then((result: any) => {
                saving.setFalse();
                if (result.status === 200) onClose('success');
                else onClose('error');
            })
            .catch(() => {
                saving.setFalse();
                onClose('error');
            });
    };

    return (
        <CustomDialog
            onClose={onClose}
            aria-labelledby="delete-critical-variable"
            fullWidth={false}
            maxWidth={false}
            scroll="paper"
            open={open}
            className="delete-cv-dialog"
        >
            <DialogTitle id="reset-password-modal-title" className="delete-cv-title">
                {t('login:resetPassword')}
                <FontAwesomeIcon
                    icon={['fal', 'times']}
                    className="fa-lg close-icon-cv"
                    onClick={() => {
                        onClose();
                    }}
                    data-testid="close-dialog"
                />
            </DialogTitle>

            <DialogContent className="dialog-content reset-password">
                <span className="confirm-text">{t('login:resetPasswordText', { email })}</span>
                <span className="confirm-text">{t('login:wouldToDoReset')}</span>
            </DialogContent>

            <DialogActions className="delete-cv-actions">
                <Button
                    className="delete-cv-btn"
                    id="reset-pass-user"
                    disabled={saving.value}
                    text="login:resetPassword"
                    onClick={() => {
                        resetPassword();
                    }}
                />
            </DialogActions>
        </CustomDialog>
    );
};

export default ResetPasswordModal;
